import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Tooltip from "components/Tooltip";

import styles from "./Action.css";

const Action = ({ icon, isActive, onClick, text, tooltip, tooltipAfterClick }) => {
  const Icon = icon;
  const action = (
    <div className={classnames(styles.action, { [styles.active]: isActive })} onClick={onClick}>
      {icon ? <Icon size="xs" /> : <span>{text}</span>}
    </div>
  );

  return tooltip ? (
    <Tooltip tip={action} tooltip={tooltip} tooltipAfterClick={tooltipAfterClick} />
  ) : (
    action
  );
};

Action.propTypes = {
  icon: PropTypes.func,
  text: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipAfterClick: PropTypes.string,
};

Action.defaultProps = {
  text: "",
};

export default Action;
